import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as InfoCircleSVG } from "go-list/core/images/circle-info.svg";
import { SubscriptionVisibility } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { selectOrganization } from "../../../../../../../../services/organizations/selectors";

interface Props {
	subscriptionsVisibility: SubscriptionVisibility;
}

const EmptySubscriptionsPreview = ({ subscriptionsVisibility }: Props) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);

	if (subscriptionsVisibility === SubscriptionVisibility.HIDDEN) return <></>;

	return (
		<div className="d-flex flex-column align-items-center text-center empty-subscriptions-box mb-3">
			<InfoCircleSVG />
			<span className="mt-2">{t("modules.subscription.field.empty_subscriptions.title")}</span>
			{subscriptionsVisibility === SubscriptionVisibility.VISIBLE && (
				<>
					<span className="mb-2">{t("modules.subscription.action.add_and_create.title")}</span>
					<Link className={"btn btn-primary"} to={`/${organization.id}/subscriptions/edit`}>{`+${t(
						"common.action.add",
						{ ns: "lib" }
					)}`}</Link>
				</>
			)}
		</div>
	);
};

export default EmptySubscriptionsPreview;
